import axios from '../../axios'
import UserStore from '@stores/UserStore'

interface IParams {
  pageSize: number
  pageNo: number
}

export default {
  /**
   * 新问卷列表
   */
  newQuestionnaireList: ({ pageSize, pageNo }: IParams) =>
    axios.post(
      '/learn/app/clientapi/question/new/listQuestionnaire.do',
      { pageNo, pageSize },
      {
        headers: {
          sid: UserStore.getSid(),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }
    ),

  // 获取新问卷详情
  getQuestionnaireDetail: (id: string) =>
    axios.get('/learn/app/clientapi/question/new/getQuestionnaire.do', {
      params: {
        id,
      },
      headers: {
        sid: UserStore.getSid(),
      },
    }),
}
